var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border_dark"
  }, [_c('div', {
    staticClass: "color_blue",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.totalBoxes')) + ":" + _vm._s(_vm.box.length))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "auto"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('orders.totalQTY')) + ":" + _vm._s(_vm.qty) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "float": "right",
      "margin-left": "auto"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('packingb2b.totalWeight')) + ":" + _vm._s(_vm.totalBoxweight) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 5px 10px 5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "searchboxid",
      "placeholder": _vm.$t('ShippingDetails.boxIDPlaceHolder')
    },
    model: {
      value: (_vm.searchboxid),
      callback: function($$v) {
        _vm.searchboxid = $$v
      },
      expression: "searchboxid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchbox
    }
  }, [_vm._v("\n       " + _vm._s(_vm.$t('common.searchBtn')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSearchBox
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.resetBtn')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60vh",
      "width": "100%",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.box), function(boxitem, boxid) {
    return _c('div', {
      key: boxid,
      staticClass: "form-group"
    }, [_c('singleBox', {
      key: "abc",
      attrs: {
        "boxdata": boxitem,
        "clientid": _vm.clientid,
        "disableflag": _vm.disableflag
      }
    })], 1)
  }))])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-693e9372", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693e9372","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common_components/packingBoxList.vue
// module id = 2085
// module chunks = 0